import React from 'react';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';

function Error_404() {
    return (
        <div>
            <Navbar page={""}/>
            <div className='anim-fade-in mt-14 max-w-5xl mx-auto pt-8 md:pt-14 px-5'>
                <h3 className='text-4xl md:text-5xl font-bold tracking-wide mb-1 md:mb-2'>404 Not Found</h3>
                <p className='text-2xl mb-5 md:mb-10 text-gray-700'>It looks like the page you are looking for does not exist.</p>
                <Link to={'/'} className='bg-gray-800 hover:bg-gray-900 p-3 text-white rounded'><i className="fa-solid fa-house mr-1.5"></i>Go to homepage</Link>
            </div>
        </div>
    )
}

export default React.memo(Error_404);